// src/axiosClient.js

import axios from 'axios';
import config from '../config';

// Create a single Axios instance with the base URL and default headers
const axiosClient = axios.create({
  baseURL: `${config.API_URL}/api/v1`, // Base URL for your API
  headers: {
    'Content-Type': 'application/json', // Default headers
  },
});

// Optional: Add an interceptor for request/response handling
// Request interceptor to add the Bearer token
axiosClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token") || null
    
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosClient.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Handle 403 Forbidden response
    if (error.response && error.response.status === 403) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/sign-in';
    }
    return Promise.reject(error);
  }
);

export default axiosClient;